"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FilterConfirm_1 = __importDefault(require("../FilterConfirm"));
var RangeSelect = /** @class */ (function (_super) {
    __extends(RangeSelect, _super);
    function RangeSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.toInputRef = react_1.default.createRef();
        _this.blurFromInput = function () {
            var to = _this.state.to;
            var from = _this.state.from;
            if (to && from && from > to) {
                to = from;
            }
            _this.setState({
                to: to,
            });
            if (_this.toInputRef.current) {
                _this.toInputRef.current.focus();
            }
        };
        _this.blurToInput = function () {
            var from = _this.state.from;
            var to = _this.state.to;
            if (to && from && to < from) {
                from = to;
            }
            _this.setState({
                from: from,
            });
        };
        _this.changeFromInput = function (event) {
            var value;
            if (event.currentTarget.value !== "") {
                value = parseFloat(event.currentTarget.value);
            }
            _this.setState({
                from: value,
            });
        };
        _this.changeToInput = function (event) {
            var value;
            if (event.currentTarget.value !== "") {
                value = parseFloat(event.currentTarget.value);
            }
            _this.setState({
                to: value,
            });
        };
        _this.onConfirmClick = function () {
            _this.props.onChange(_this.state.from, _this.state.to);
        };
        _this.onResetClick = function () {
            _this.setState({
                from: undefined,
                to: undefined,
            });
            _this.props.onChange(undefined, undefined);
        };
        _this.state = {
            from: props.from,
            to: props.to,
        };
        return _this;
    }
    RangeSelect.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.from !== prevState.prevPropsFrom || nextProps.to !== prevState.prevPropsTo) {
            return {
                from: nextProps.from,
                to: nextProps.to,
                prevPropsFrom: nextProps.from,
                prevPropsTo: nextProps.to,
            };
        }
        return null;
    };
    RangeSelect.prototype.render = function () {
        var _a = this.props, min = _a.min, max = _a.max, step = _a.step;
        var from = this.state.from;
        var to = this.state.to;
        if (from === undefined) {
            from = "";
        }
        if (to === undefined) {
            to = "";
        }
        return (react_1.default.createElement(FilterConfirm_1.default, { onConfirmClick: this.onConfirmClick, onResetClick: this.onResetClick },
            react_1.default.createElement("div", { className: "range_select row" },
                react_1.default.createElement("div", { className: "range_select__from col-6 " },
                    react_1.default.createElement("div", { className: "respect__input_div" },
                        react_1.default.createElement("input", { className: "respect__input", type: "number", value: from, min: min, max: to, step: step, onChange: this.changeFromInput, onBlur: this.blurFromInput }))),
                react_1.default.createElement("div", { className: "range_select__to col-6" },
                    react_1.default.createElement("div", { className: "respect__input_div" },
                        react_1.default.createElement("input", { className: "respect__input", type: "number", value: to, min: from, max: max, step: step, onChange: this.changeToInput, onBlur: this.blurToInput, ref: this.toInputRef }))))));
    };
    return RangeSelect;
}(react_1.default.Component));
exports.default = RangeSelect;
//# sourceMappingURL=index.js.map